// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"af2c4885","590":"227c536d"}[chunkId] + ".chunk.js";
};